(function() {

  localStorage.removeItem('quiz_products');
  window.quizProducts = [];

  // Variáveis globais
  window.quizSteps = document.querySelectorAll('.quiz-step');
  window.quizCurrent = 0;
  window.quizProducts = [];

  if (!window.quizSteps.length) {
    console.warn('No step found');
    return;
  }

  // Carrega produtos salvos
  const savedProducts = localStorage.getItem('quiz_products');
  if (savedProducts) {
    try {
      window.quizProducts = JSON.parse(savedProducts);
    } catch (e) {
      console.warn('Error parsing saved products');
    }
  } else {
    localStorage.removeItem('quiz_products');
  }

  function showStep(i) {
    if (i < 0) i = 0;
    if (i >= window.quizSteps.length) {
      finishQuiz();
      return;
    }

    window.quizSteps.forEach(step => step.classList.remove('active'));
    window.quizSteps[i].classList.add('active');
  }

  function finishQuiz() {
    window.quizSteps.forEach(step => step.style.display = 'none');

    const resultSection = document.querySelector('.quiz-result');
    if (resultSection) resultSection.style.display = 'block';

    renderResults();
  }

  function renderResults() {
    const grid = document.getElementById('quiz-result-grid');
    if (!grid) return;

    grid.innerHTML = '';

    if (!window.quizProducts || window.quizProducts.length === 0) {
      grid.innerHTML = '<p>No products selected</p>';
      return;
    }

    const uniqueProducts = [...new Set(window.quizProducts)]
      .map(handle => handle.trim().toLowerCase())
      .filter(handle => handle !== '');


    const allTemplates = [];
    document.querySelectorAll('.section-templates [data-product-template]').forEach(template => {
      allTemplates.push(template);
    });

    console.log('Found templates:', allTemplates.length);

    let productsFound = 0;

    uniqueProducts.forEach(handle => {

      const template = allTemplates.find(t => 
        t.dataset.productTemplate.toLowerCase() === handle
      );

      if (template) {
        const productHtml = template.innerHTML;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = productHtml;
        const productElement = tempDiv.firstElementChild;
        
        if (productElement) {
          grid.appendChild(productElement);
          productsFound++;
        }
      } else {
        console.warn('Template not found', handle);
      }
    });

    if (productsFound === 0) {
      grid.innerHTML = '<p>No products found.</p>';
    } else {

      setupQuickAdd();
    }
  }

  function setupQuickAdd() {
    document.querySelectorAll('.quick-add-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const variantId = this.dataset.variantId;
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(response => response.json())
        .then(() => {
          this.textContent = 'Added!';
          setTimeout(() => {
            this.textContent = 'Quick Add';
          }, 2000);
        })
        .catch(error => {
          console.error('Erro:', error);
          this.textContent = 'Erro';
        });
      });
    });
  }

  document.addEventListener('click', function(e) {
    // Quando clica em uma resposta
const answer = e.target.closest('.quiz-answer');
if (answer) {
  e.preventDefault();
  
  const handle = answer.dataset.productHandle;
  
  // Adiciona se existir handle (mesmo vazio? não)
  if (handle) {
    window.quizProducts.push(handle.toLowerCase());
    localStorage.setItem('quiz_products', JSON.stringify(window.quizProducts));
  }
  
  window.quizCurrent++;
  showStep(window.quizCurrent);
}

    const prevButton = e.target.closest('.quiz-prev');
    if (prevButton) {
      if (window.quizCurrent > 0) {
        window.quizCurrent--;
        showStep(window.quizCurrent);
      }
    }

    const restartButton = e.target.closest('.quiz-restart');
    if (restartButton) {
      localStorage.removeItem('quiz_products');
      window.quizProducts = [];
      location.reload();
    }
  });

  // Inicializa
  if (window.quizProducts.length > 0) {
    window.quizCurrent = window.quizProducts.length;
    if (window.quizCurrent >= window.quizSteps.length) {
      finishQuiz();
    } else {
      showStep(window.quizCurrent);
    }
  } else {
    showStep(0);
  }
})();